import { render, staticRenderFns } from "./reward-module.vue?vue&type=template&id=770d2bb3&scoped=true"
import script from "./reward-module.vue?vue&type=script&lang=ts"
export * from "./reward-module.vue?vue&type=script&lang=ts"
import style0 from "./reward-module.vue?vue&type=style&index=0&id=770d2bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_coffee-script@1.12.7_css-loader@5.2.7_webpa_35f4d3d5eaf4581d12c76a04842072e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d2bb3",
  null
  
)

export default component.exports